@if (races.length) {
    @for (fixture of races; track fixture.id; let i = $index) {
        <div class="greyhound-next-races" @fade>
            <section class="horses-race-details greyhound-box">
                <div>
                    <header class="next-races-main-header">
                        <div class="greyhound-race-info">
                            <span class="location-name flx-1"> {{ fixture.startDate | date: 'HH:mm' }} {{ fixture.meeting.name | msTranslate }}</span>
                            <div>
                                <ms-greyhound-timer [race]="fixture" [timeInSeconds]="countDownTime(fixture)" />
                            </div>
                        </div>
                        <div class="greyhound-race-info">
                            <div class="flx-1">
                                <ms-gh-race-info msTextAutoScroll class="race-name" [race]="fixture" [marketTitle]="marketTitle" />
                            </div>
                            <div class="greyhound-more-link">
                                <a [href]="getFixtureLink(fixture)" (click)="track(fixture, i)">{{ sitecore.horseRacing.common.MoreLink }} </a>
                                <a [href]="getFixtureLink(fixture)" (click)="track(fixture, i)">
                                    <vn-icon name="theme-up" size="12" class="more-icon" />
                                </a>
                            </div>
                        </div>
                    </header>
                    @if (!fixture.isOptionBet) {
                        <ms-gh-win-market-participants
                            [fixture]="fixture"
                            [displayRunners]="displayRunners"
                            [trackingSource]="trackingSource"
                            [sortBy]="sortBy"
                            [isNextRaces]="true" />
                    }
                    @if (fixture.isOptionBet && fixture.optionGroups.length > 0) {
                        <ms-gh-derived-win-market-participants
                            [isNextRaces]="true"
                            [optionGroup]="getOptionGroup(fixture)"
                            [displayType]="getDisplayType(fixture)"
                            [participantOptionGroups]="getParticipantOptionGroups(fixture)"
                            [fixture]="fixture"
                            [greyhoundTrapDogMapping]="greyhoundTrapAndDogMapper(fixture)"
                            [optionPickTrackingsource]="trackingSource" />
                    }
                </div>
            </section>
        </div>
    }
}
